import * as actions from "./actions";
import * as creditSettlementActions from "../creditSettlement/actions";

import _ from "underscore";

let initialState = {
  fetching: false,
  fetched: false,
  error: null,
  table: {
    currentFilter: null,
    pagination: { page: 1, take: 10 },
  },
  data: [],
  performingCount: 0,
  loansAreUpdating: false,
};

const loans = (state = initialState, action) => {
  switch (action.type) {
    // GET APPLICATIONS
    case actions.LOAN_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
        fetchError: null,
        data: [],
        selected: action.additionalData,
      });

    case actions.LOAN_LIST_GET_SUCCESS: {
      const data = Array.isArray(action.response)
        ? action.response
        : [action.response];
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        data,
      });
    }
    case actions.LOAN_LIST_GET_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        error: action.error,
      });

    // GET PERFORMING FOR DASHBOARD
    case actions.GET_PERFORMING_REQUEST:
      return Object.assign({}, state, {
        performingCount: 0,
      });

    case actions.GET_PERFORMING_SUCCESS: {
      const performing = (
        Array.isArray(action.response) ? action.response : [action.response]
      ).length;
      return Object.assign({}, state, {
        performingCount: performing ? performing : 0,
      });
    }

    case actions.GET_PERFORMING_ERROR:
      return Object.assign({}, state, {
        performingCount: 0,
      });

    case actions.LOAN_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          pagination: Object.assign({}, state.table.pagination, {
            page: action.page,
          }),
        }),
      });

    case actions.LOAN_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          currentFilter: Object.assign({}, state.table.currentFilter, {
            ...action.filter,
          }),
        }),
      });

    // Credit settlement actions
    case creditSettlementActions.CREDIT_SETTLEMENT_SET_DCA_PROCESS_REQUEST: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          settingDCA: false,
          setDCA: false,
          setDCAError: null,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }

    case creditSettlementActions.CREDIT_SETTLEMENT_SET_DCA_PROCESS_SUCCESS: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          CreditStage: "DCAProcess",
          DCAMonthlyData: {},
          settingDCA: false,
          setDCA: true,
          setDCAError: null,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }
    case creditSettlementActions.CREDIT_SETTLEMENT_SET_DCA_PROCESS_ERROR: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          settingDCA: false,
          setDCA: false,
          setDCAError: action.error,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }
    case creditSettlementActions.CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_REQUEST: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          closingDCA: false,
          closedDCA: false,
          closingDCAError: null,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }
    case creditSettlementActions.CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_SUCCESS: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          CreditStage: "CreditManuallyClosedInDCA",
          closingDCA: false,
          closedDCA: true,
          closingDCAError: null,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }
    case creditSettlementActions.CREDIT_SETTLEMENT_CLOSE_DCA_PROCESS_ERROR: {
      let creditId = action.dataSent.CreditId;
      let toChangeIndex = _.findIndex(state.data, (item) => {
        return item.Id == creditId;
      });

      if (toChangeIndex > -1) {
        let toChange = Object.assign({}, state.data[toChangeIndex], {
          closingDCA: false,
          closedDCA: false,
          closingDCAError: action.error,
        });

        return Object.assign({}, state, {
          data: [
            ...state.data.slice(0, toChangeIndex),
            toChange,
            ...state.data.slice(toChangeIndex + 1),
          ],
        });
      }

      return state;
    }

    default:
      return state;
  }
};

export default loans;
